// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7023) FIXME: 'CourseReservesDetailScroll' implicitly has return... Remove this comment to see the full error message
var CourseReservesDetailScroll = function(courseReserves: any) {
   // @ts-expect-error TS(2322) FIXME: Type 'typeof CourseReservesDetailScroll' is not as... Remove this comment to see the full error message
   return CourseReservesDetailScroll = class CourseReservesDetailScroll {
      scope: any

      constructor(scope: any) {
         this.scrolled = this.scrolled.bind(this)
         this.scope = scope
      }

      scrolled(loadMore: any) {
      // Similar behavior as search but controlled by the tab selection
         if (!this.scope.view ||
        this.scope.layout.modal ||
        this.scope.loadingNewSearchIndicator ||
        this.scope.loadingSearchIndicator ||
        courseReserves.detailScope.allLoaded) { return }

         const resultList = angular.element("#courseReserveDetail")
         if (resultList.is(":visible") && loadMore) { return courseReserves.getDetailDocs() }
      }
   }
}

CourseReservesDetailScroll.$inject = ['courseReserveService']

angular.module('summonApp.factories.scrolls')
   .factory('courseReservesDetailScroll', CourseReservesDetailScroll)
